import type { DomainError } from '@core/domain';
import { Dialog, LoadingSpinner } from '@soteria/design-system-ve';

import * as styles from './DeleteDialog.css';
import { ErrorBanner } from './ErrorBanner';

interface DeleteDialogProps {
  isOpen: boolean;
  isDeleting?: boolean;
  errors?: DomainError[] | null;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  title: string;
  description: string;
  itemName: string;
  itemType: string;
}

/**
 * Delete Dialog
 *
 * Generic component for confirming deletion of any item type
 */
export function DeleteDialog({ isOpen, isDeleting = false, errors = null, onClose, onConfirm, title, description, itemName, itemType }: DeleteDialogProps) {
  return (
    <Dialog
      cancelAction={{
        label: 'Cancel',
        disabled: isDeleting,
      }}
      description={description}
      isOpen={isOpen}
      primaryAction={{
        label: isDeleting ? <LoadingSpinner /> : 'Yes, Delete',
        onClick: async () => {
          await onConfirm();
        },
        variant: 'danger',
        disabled: isDeleting,
      }}
      size="md"
      title={title}
      onClose={onClose}
    >
      <div className={styles.contentContainer}>
        {/* Error Banner  */}
        {errors && errors.length > 0 && <ErrorBanner errors={errors} title={`Failed to delete ${itemType.toLowerCase()}:`} />}

        <div className={styles.messageContainer}>
          <p>
            You are about to delete the {itemType.toLowerCase()} <strong>{itemName}</strong>. This action cannot be undone. All data associated with this{' '}
            {itemType.toLowerCase()} will be permanently deleted.
          </p>
        </div>
      </div>
    </Dialog>
  );
}
